<template>
  <label class="relative inline-flex items-center cursor-pointer">
    <input
      type="checkbox"
      :value="value"
      class="sr-only peer"
      :checked="value"
      @click="toggle"
    >
    <div class="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-primary-300 dark:peer-focus:ring-primary-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primary-600" />
    <span
      v-if="label"
      class="ml-3 text-sm font-medium text-muted-900 dark:text-muted-300"
    >
      {{ label }}
    </span>
  </label>
</template>

<script>
export default {
  name: 'ToggleComponent',
  props: {
    id: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    }
  },
  computed: {
    inputId() {
      return this.id || this.label.toLowerCase().replace(' ', '-');
    }
  },
  methods: {
    toggle() {
      this.$emit('input', !this.value);
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
